import { useCallback, useEffect, useRef } from 'react';

/**
 * 回傳一個 setTimeout，元件卸載時自動清掉尚未執行的 timer；卸載後才呼叫會直接略過。
 *
 * 用於「成功後延遲導頁」：成功提示顯示 1.5～3 秒後才導頁，期間使用者若已經離開頁面，
 * timer 沒清掉就會把人拉回去。呼叫點通常在 await API 之後，請求途中就離開的話，
 * 呼叫當下元件已卸載，所以也要擋掉。
 *
 * @returns {Function} (callback, delay) => void
 */
export function useUnmountSafeTimeout() {
  const timerIdsRef = useRef(new Set());
  const isMountedRef = useRef(false);

  useEffect(() => {
    const timerIds = timerIdsRef.current;
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      timerIds.forEach(clearTimeout);
      timerIds.clear();
    };
  }, []);

  return useCallback((callback, delay) => {
    if (!isMountedRef.current) return;
    const id = setTimeout(() => {
      timerIdsRef.current.delete(id);
      callback();
    }, delay);
    timerIdsRef.current.add(id);
  }, []);
}
